/**
 * Config loader
 *
 * @author Igor Zaporozhets <i.zaporozhets@infomir.com>
 */

'use strict';

/* eslint new-cap: 0 */

var parallel = require('cjs-async/parallel'),

    currentPlatform = {
        model: null,
        version: null
    },

    useVersions = true,

    MAJOR_VERSION = 0,
    MINOR_VERSION = 1,
    PATCH_VERSION = 2,

    height, deviceModelName;

if ( PLATFORM === 'MAG' || NANOCORE ) {
    currentPlatform.version = window.gSTB.GetDeviceImageVersionCurrent().split('-')[0].split('.').map(Number);
    currentPlatform.model = top.gSTB.GetDeviceModelExt ? top.gSTB.GetDeviceModelExt() : top.gSTB.GetDeviceModel();
    deviceModelName = top.gSTB.GetDeviceModel();
}

if ( DEVELOP ) {
    debug('mag')('model ' + currentPlatform.model);
    debug('mag')('version ' + currentPlatform.version);
}


function fixUris ( appConfig, basePath, pluginsPath ) {
    var urlParts = [];

    if ( typeof appConfig.url !== 'string' || appConfig.type === 'plugin' ) {
        if ( appConfig.type === 'plugin' ) {
            if ( appConfig.url && appConfig.url.indexOf('.js') !== -1 ) {
                urlParts.push(appConfig.url);
                appConfig.path = appConfig.url + '/../';
            } else {
                urlParts.push(pluginsPath);
                urlParts.push(appConfig.packageName);
                if ( useVersions ) {
                    urlParts.push(appConfig.version);
                }
                urlParts.push(appConfig.uris.app || '');
                appConfig.path = urlParts.join('/');
                urlParts.push(appConfig.uris.entry || 'index.js');
            }
        } else if ( appConfig.uris.entry && appConfig.uris.entry.indexOf('://') !== -1 ) {
            urlParts.push(appConfig.uris.entry);
        } else if ( appConfig.uris.app && appConfig.uris.app.indexOf('://') > -1 ) {
            urlParts.push(appConfig.uris.app);
            urlParts.push(appConfig.uris.entry);
        } else {
            urlParts.push(basePath);
            urlParts.push(appConfig.packageName);
            if ( useVersions ) {
                urlParts.push(appConfig.version || '');
            }
            urlParts.push(appConfig.uris.app || 'app');
            urlParts.push(appConfig.uris.entry || 'index.html');
        }
        appConfig.url = urlParts.join('/');
        //.replace(/\/\//g, '/');
    }

    if ( DEVELOP ) {
        debug('config')('app uri: ' + appConfig.url);
    }
}


/* eslint max-statements: 0 */
function normalizeAppConfig ( appConfig, globalOptions ) {
    var basePath = globalOptions.appsPackagesPath,
        dependencies = Object.keys(appConfig.dependencies || []),
        versions = dependencies.map(function ( item ) {
            return appConfig.dependencies[item];
        }),
        options = [],
        urlParts = [],
        protocol, icon;

    if ( dependencies.length > 0 ) {
        appConfig.dependencies = {};
        dependencies.forEach(function ( dependency, index ) {
            if ( dependency.indexOf('plugin') !== -1 ) {
                appConfig.dependencies[dependency] = versions[index];
            }
        });
    }

    appConfig.uris = appConfig.uris || {};

    if ( PLATFORM === 'MAG' && MODE === 'MINISTRA' ) {
        if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
            basePath = location.href
                .replace(location.search, '')
                .replace(location.hash, '') +
                '/' + globalOptions.appsPackagesPath;

        } else if ( globalOptions.appsPackagesPath.indexOf('://') === -1 ) {
            basePath = globalOptions.stalkerHost + '/' + globalOptions.appsPackagesPath;
        } else {
            basePath = globalOptions.appsPackagesPath;
        }
    } else {
        if ( globalOptions.appsPackagesPath.indexOf('://') === -1 ) {
            // relative path
            basePath = location.href.replace(location.search, '').replace(location.hash, '') +
                '/' + globalOptions.appsPackagesPath;
        }
        if ( PLATFORM === 'BROWSER' ) {
            basePath = globalOptions.appsPackagesPath;
        }
    }

    fixUris(appConfig, basePath, globalOptions.pluginsPath);

    if ( appConfig.options ) {
        Object.keys(appConfig.options).forEach(function ( name ) {
            options.push(name + '=' + appConfig.options[name]);
        });
        if ( options.length > 0 ) {
            appConfig.url += '?';
            appConfig.url += options.join('&');
        }
    }
    urlParts = appConfig.url.split('/');
    protocol = urlParts.shift() + '/';
    while ( urlParts[0].length === 0 ) {
        protocol += '/';
        urlParts.shift();
    }
    appConfig.url = protocol + urlParts.filter(Boolean).join('/');

    if ( appConfig.type !== 'plugin' ) {
        appConfig.uris.icons = appConfig.uris.icons || {};

        if ( appConfig.uris.icons[height] ) {
            appConfig.uris.icons = appConfig.uris.icons[height];

            for ( icon in appConfig.uris.icons ) {
                if ( icon.indexOf('://') === -1 ) {
                    urlParts.splice(0);
                    if ( appConfig.uris.app.indexOf('://') > -1 ) {
                        urlParts.push(appConfig.uris.app);
                        urlParts.push(appConfig.uris.icons[icon]);
                    } else {
                        urlParts.push(basePath);
                        urlParts.push(appConfig.packageName);
                        if ( useVersions && appConfig.version ) {
                            urlParts.push(appConfig.version);
                        }
                        if ( appConfig.uris.app ) {
                            urlParts.push(appConfig.uris.app);
                        }
                        urlParts.push(appConfig.uris.icons[icon]);
                    }
                    appConfig.uris.icons[icon] = urlParts.join('/');
                }
            }

            // if ( appConfig.uris.icons.logoNormal ) {
            //     if ( appConfig.uris.icons.logoNormal.indexOf('://') === -1 ) {
            //         urlParts.splice(0);
            //         if ( appConfig.uris.app.indexOf('://') > -1 ) {
            //             urlParts.push(appConfig.uris.app);
            //             urlParts.push(appConfig.uris.icons.logoNormal);
            //         } else {
            //             urlParts.push(basePath);
            //             urlParts.push(appConfig.packageName);
            //             if ( appConfig.version ) {
            //                 urlParts.push(appConfig.version);
            //             }
            //             if ( appConfig.uris.app ) {
            //                 urlParts.push(appConfig.uris.app);
            //             }
            //             urlParts.push(appConfig.uris.icons.logoNormal);
            //         }
            //         appConfig.uris.icons.logoNormal = urlParts.join('/');
            //     }
            // }

            // if ( appConfig.uris.icons.logoActive ) {
            //     if ( appConfig.uris.icons.logoActive.indexOf('://') === -1 ) {
            //         urlParts.splice(0);
            //         if ( appConfig.uris.app.indexOf('://') > -1 ) {
            //             urlParts.push(appConfig.uris.app);
            //             urlParts.push(appConfig.uris.icons.logoActive);
            //         } else {
            //             urlParts.push(basePath);
            //             urlParts.push(appConfig.packageName);
            //             if ( appConfig.version ) {
            //                 urlParts.push(appConfig.version);
            //             }
            //             if ( appConfig.uris.app ) {
            //                 urlParts.push(appConfig.uris.app);
            //             }
            //             urlParts.push(appConfig.uris.icons.logoActive);
            //         }
            //         appConfig.uris.icons.logoActive = urlParts.join('/');
            //     }
            // }
        }

        appConfig.colors = appConfig.colors || {};
        appConfig.colors.splashFont = appConfig.colors.splashFont || '#fff';
        appConfig.colors.splashBackground = appConfig.colors.splashBackground || '#333';
    }

    appConfig.icons = appConfig.icons || {};

    return appConfig;
}


function validVersion ( required ) {
    if ( required !== '*') {
        required = required.split('.');
        console.log(currentPlatform.version, required);

        if ( required[MAJOR_VERSION] !== '*' ) {
            if ( Number(required[MAJOR_VERSION]) !== currentPlatform.version[MAJOR_VERSION] ) {
                return false;
            }
        }

        if ( required[MINOR_VERSION] !== '*' ) {
            if ( Number(required[MINOR_VERSION]) === currentPlatform.version[MINOR_VERSION] ) {
                if ( required[PATCH_VERSION] === '*' ) {
                    return true;
                }

                return Number(required[PATCH_VERSION]) === currentPlatform.version[PATCH_VERSION];
            }

            return false;
        }
    }

    return true;
}

/**
 *
 * @param {Object} config - package config
 * @param {string} customModel - specified device model
 *
 * @example
 *
 * isNativePlatform({
 *    platforms: {
 *      exclude: {
 *         MAG275: '*'
 *      },
 *      MAG254: '*',
 *      AndroidAPP: '*',
 *      AndroidSTB: {
 *        'MAG425A': '*'
 *      }
 *    }
 * });
 */
function isNativePlatform ( config, customModel ) {
    var models, index, size, model;

    if ( config.platforms ) {
        if ( customModel ) {
            model = customModel;
        } else {
            model = currentPlatform.model;
        }

        models = Object.keys(config.platforms);
        index = 0;
        size = models.length;

        console.log(typeof config.platforms['exclude'] !== 'undefined', 'und');
        if ( typeof config.platforms['exclude'] !== 'undefined' ) {
            console.log(model, typeof config.platforms['exclude'][model]);
            if ( typeof config.platforms['exclude'][model] === 'undefined' ) {
                return true;
            }

            console.log(model);
            console.log(config.platforms['exclude'][model]);
            if ( typeof config.platforms['exclude'][model] === 'object' ) {
                return isNativePlatform(
                    {
                        platforms: {
                            exclude: config.platforms['exclude'][model]
                        }
                    },
                    deviceModelName
                );
            }

            return !validVersion(config.platforms['exclude'][model]);
        }

        while ( index < size ) {
            if ( models[index] === model ) {
                if ( typeof config.platforms[models[index]] === 'object' ) {
                    return isNativePlatform(
                        {
                            platforms: config.platforms[models[index]]
                        },
                        deviceModelName
                    );
                } else if ( validVersion(config.platforms[models[index]]) ) {
                    return true;
                }
            }
            ++index;
        }

        return false;
    }

    return true;
}


function prepareConfig ( remoteConfig, localConfig, callback ) {
    var overriddenAppList = localConfig ? localConfig.apps : [],
        overriddenAppMap = {},
        index = 0,
        apps = [],
        themes, theme, size, appId, xhr, $anchor;

    if ( !remoteConfig.apps ) {
        remoteConfig.apps = [];
    }

    if ( remoteConfig.options.ignoreVersions ) {
        useVersions = false;
    }

    if ( remoteConfig.options.pluginsPath.indexOf('../') !== -1 ) {
        $anchor = document.createElement('a');
        $anchor.href = remoteConfig.options.pluginsPath;
        remoteConfig.options.pluginsPath = $anchor.href;
    }

    if ( PLATFORM === 'MAG' && MODE === 'MINISTRA' ) {
        size = remoteConfig.apps.length;

        while ( index < size ) {
            if ( isNativePlatform(remoteConfig.apps[index]) ) {
                if ( DEVELOP ) {
                    debug('config')('add package ' + remoteConfig.apps[index].packageName);
                }
                apps.push(remoteConfig.apps[index]);
            } else if ( DEVELOP ) {
                debug('config')('remove package ' + remoteConfig.apps[index].packageName);
            }

            ++index;
        }

        remoteConfig.apps = apps;
    }


    overriddenAppList.forEach(function ( overriddenAppConfig ) {
        overriddenAppMap[overriddenAppConfig.packageName || overriddenAppConfig.name] = overriddenAppConfig;
    });
    overriddenAppList.splice(0);

    size = remoteConfig.apps.length;
    index = 0;

    // fix icon paths
    while ( index < size ) {
        remoteConfig.apps[index] = normalizeAppConfig(remoteConfig.apps[index], remoteConfig.options);
        appId = remoteConfig.apps[index].packageName || remoteConfig.apps[index].name;

        if ( overriddenAppMap[appId] ) {
            remoteConfig.apps[index].locked = overriddenAppMap[appId].locked;
        }

        ++index;
    }

    index = 0;
    if ( remoteConfig.options.themePath ) {
        remoteConfig.theme = remoteConfig.options.stalkerHost + remoteConfig.options.themePath.replace('{screen_height}', height + '.css');
        remoteConfig.themeVars = remoteConfig.themes = {};
        callback(null, remoteConfig);
    } else {
        themes = Object.keys(remoteConfig.themes);
        size = themes.length;

        while ( index < size ) {
            theme = remoteConfig.themes[themes[index]];

            if ( theme.indexOf('://') === -1 ) {
                if ( MODE === 'MINISTRA' ) {
                    if ( PLATFORM === 'MAG' ) {
                        if ( remoteConfig.options.appsPackagesPath.indexOf('://') === -1 ) {
                            remoteConfig.themes[themes[index]] = '' + remoteConfig.options.stalkerHost + '/' +
                                remoteConfig.options.appsPackagesPath + '/' + themes[index] + '/' + theme + '/';
                        } else {
                            remoteConfig.themes[themes[index]] = remoteConfig.options.appsPackagesPath + '/' + themes[index] + '/' + theme + '/';
                        }
                    } else {
                        remoteConfig.themes[themes[index]] = location.href.replace(location.search, '').replace(location.hash, '') +
                            '/' + remoteConfig.options.appsPackagesPath + '/' + themes[index] + '/' + theme + '/';
                    }
                } else if ( PLATFORM === 'MAG' || NANOCORE ) {
                    if ( remoteConfig.options.appsPackagesPath.indexOf('://') === -1 ) {
                        remoteConfig.themes[themes[index]] = location.href.replace(location.search, '').replace(location.hash, '') +
                            '/' + remoteConfig.options.appsPackagesPath + '/' + themes[index] + '/' + theme + '/';
                    } else {
                        remoteConfig.themes[themes[index]] = remoteConfig.options.appsPackagesPath + '/' + themes[index] + '/' + theme + '/';
                    }
                }
            }
            ++index;
        }
        remoteConfig.theme = remoteConfig.themes[themes[0]];

        xhr = new XMLHttpRequest();
        xhr.onload = function () {
            if ( this.status === 200 && this.responseText )  {
                try {
                    remoteConfig.themeVars = JSON.parse(this.responseText);
                } catch ( exception ) {
                    remoteConfig.themeVars = {};
                }
            }
            callback(null, remoteConfig);
        };
        xhr.open('GET', remoteConfig.theme + 'src/vars.json');
        xhr.send();

        xhr.onerror = xhr.ontimeout = function () {
            callback(null, remoteConfig);
        };
    }

    if ( DEVELOP ) {
        debug('kernel')(JSON.stringify(remoteConfig.theme));
    }
}


height = screen.height;
switch ( height ) {
    case 480:
    case 576:
    case 720:
    case 1080:
        break;

    default:
        height = 720;
        break;
}

/**
 * Clear and fill the manager with the given list of pages.
 *
 * @param {Object} config options
 * @param {string} config.link config address to load
 * @param {function} callback hook on ready
 */
module.exports = {
    systemSettings: {},
    settings: {},
    environment: {},
    data: {},
    url: null,
    load: function ( args, allDone ) {
        var languages = require('../../../../../../config').languages,
            self = this,
            localizedNames = null,
            configPath, environmentLanguage;

        if ( DEVELOP ) {
            debug('config')('start load');
        }

        // default is local file
        if ( args.config ) {
            configPath = args.config;
        } else if ( MODE === 'PORTAL' && PLATFORM === 'MAG' ) {
            configPath = 'config/' + currentPlatform.model + '.json';
        } else if ( MODE === 'MINISTRA' && (TARGET === 'android-stb' || TARGET === 'android-app') ) {
            environmentLanguage = require('../system/environment').language;
            if ( languages.indexOf(environmentLanguage) === -1 ) {
                configPath = 'config.en.json';
            } else {
                configPath = 'config.' + environmentLanguage + '.json';
            }
        } else {
            configPath = 'config.json';
        }
        this.url = configPath;

        parallel([
            function remoteConfigLoader ( done ) {
                var xhr = new XMLHttpRequest();

                xhr.onload = function () {
                    var error = false;

                    try {
                        self.data = JSON.parse(xhr.responseText);
                    } catch ( exception ) {
                        error = 'config url ' + configPath + '<br>' +
                            'config content: ' + xhr.responseText + '<br>response status ' +  xhr.status + '<br>' + exception;
                    }

                    done(error, self.data);
                };

                xhr.onerror = xhr.ontimeout = function () {
                    done(this.status + ': ' + this.responseText);
                };

                if ( DEVELOP ) {
                    debug('config')('url: ' + configPath);
                }
                xhr.open('GET', configPath, true);
                xhr.send(null);
            },
            function localConfigLoader ( done ) {
                var xhr, loadPath;

                if ( PLATFORM === 'MAG' && MODE === 'PORTAL' ) {
                    // loading localized data
                    xhr = new XMLHttpRequest();

                    if ( languages.indexOf(require('../system/environment').language) === -1 ) {
                        loadPath = 'langs/en.json';
                    } else {
                        loadPath = 'langs/' + require('../system/environment').language + '.json';
                    }
                    xhr.onload = function () {
                        var error = false;

                        try {
                            localizedNames = JSON.parse(xhr.responseText);
                        } catch ( exception ) {
                            error = 'config url ' + loadPath + '<br>' +
                                'config content: ' + xhr.responseText + '<br>response status ' +  xhr.status + '<br>' + exception;
                        }

                        done(error, window.core.storage.getItem('config'));
                    };

                    xhr.onerror = xhr.ontimeout = function () {
                        done(this.status + ': ' + this.responseText);
                    };

                    if ( DEVELOP ) {
                        debug('config')('url: ');
                    }
                    xhr.open('GET', loadPath, true);
                    xhr.send(null);
                } else {
                    done(false, window.core.storage.getItem('config'));
                }
            }
        ], function ( error, results ) {
            if ( error ) {
                allDone(error);
            } else {
                /**
                 * self.data =
                 */
                prepareConfig(results[0], results[1], function ( err, data ) {
                    if ( localizedNames !== null ) {
                        data.apps.forEach(function ( app ) {
                            if ( localizedNames[app.packageName] ) {
                                app.name = localizedNames[app.packageName].name;
                                app.description = localizedNames[app.packageName].description;
                            }
                        });
                    }
                    self.data = data;
                    allDone();
                });
            }
        });
    }
};
